<template>
  <v-row no-gutters class="class-lesson-completion">
    <v-col md="4" cols="12">
      <p class="completion">Class completion of this {{ lessonTerm }}</p>
    </v-col>
    <v-col md="8" cols="12">
      <v-progress-linear
        color="primary"
        height="30"
        :value="
          enrolledStudents !== 0
            ? (enrolledCompletedLesson / enrolledStudents) * 100
            : 0
        "
      >
        <span class="class-completion-label">
          {{ enrolledCompletedLesson }} out of {{ enrolledStudents }} enrolled
          students
        </span>
      </v-progress-linear>
    </v-col>
  </v-row>
</template>

<script>
import ClassInvitation from '@/modules/class/models/ClassInvitation'
import { mapState } from 'vuex'

export default {
  name: 'ClassLessonCompletion',
  props: {
    lesson: {
      type: Object,
      require: true
    },
    customClass: {
      type: Object,
      require: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(['lessonTerm']),
    enrolledStudents() {
      return ClassInvitation.query()
        .where('custom_class_id', this.customClass.id)
        .count()
    },
    enrolledCompletedLesson() {
      if (!this.lesson) return 0
      return ClassInvitation.query()
        .where('custom_class_id', this.customClass.id)
        .where('completed_lessons_name', v => v.includes(this.lesson.name))
        .count()
    }
  },
  async mounted() {
    await ClassInvitation.dispatch('getClassInvitations', {
      classId: this.customClass.id
    })
  },
  methods: {}
}
</script>

<style lang="scss">
.class-lesson-completion {
  .class-completion-label {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    color: white;
    font-size: 14px;
    text-transform: uppercase;
  }

  .completion {
    line-height: 58px;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: normal;
    margin-bottom: 0;
  }
}
</style>
